export default "/_nuxt/63223af4d43857aed6e9e757dc646835.svg";